<template>
  <div class="login">
    <div class="login-header">
      <getechHeader @logoClick="goToHomePage" />
      
    </div>
     <el-row type="type" align="center" justify="center">
     <el-col :xs="24" :sm="24" :md="24" ><div class="grid-content bg-purple">
         <div ref="loginContent" class="login-content">
      <loginFrom />
    </div>
       </div></el-col>

     </el-row>
  
    <div class="login-footer">
      <copyRight />
    </div>
  </div>
</template>

<script>
  // import lottie from 'lottie-web';
  // import animationJson from '@/static/animation/login/login.json';
  import getechHeader from './components/getechHeader';
  import loginFrom from './components/loginFrom';
  import copyRight from './components/copyRight';
  import loginMixins from './mixins';

  export default {
    mixins: [loginMixins],
    components: {
      getechHeader,
      loginFrom,
      copyRight
    },
    mounted() {
      // 动画
      // lottie.loadAnimation({
      //   container: this.$refs.loginContent,
      //   renderer: 'svg',
      //   loop: true,
      //   autoplay: true,
      //   animationData: animationJson,
      //   assetsPath: '/auth/static/animation/login/'
      // });
    }
  };
</script>

<style lang="less" scoped>
  .login {
    display: flex;
    flex-direction: column;
    height: 100%;

    /deep/ .login-content {
      height: calc(100% - 148px);
      background: url('~@img/login/bg.png') no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      > svg {
        margin-left: 3%;
        width: 50% !important;
        height: auto !important;
      }
    }
  }
    .login-footer{
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  @media screen and(max-width:992px) {
     .login-content{
      background-image:none!important;;
    }
    .loginHeader{
      padding:0;
    }
  }
</style>
